import FormatListBulletedRoundedIcon from "@mui/icons-material/FormatListBulletedRounded";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import { Box, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDashboardView } from "../../../store/contexts/DashBoardViewContext";

const translationPath = "components.viewModeSelect.";

export const ViewModeSelect = memo(() => {
  const { t } = useTranslation();

  const { viewMode, onChangeViewMode } = useDashboardView();

  const changeHandler = useCallback(
    (_: React.MouseEvent<HTMLElement, MouseEvent>, value: any) => {
      if (value === null) return;
      onChangeViewMode(value);
    },
    [onChangeViewMode]
  );

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "end",
      }}
    >
      <ToggleButtonGroup
        value={viewMode}
        onChange={changeHandler}
        size="small"
        color="primary"
        exclusive
      >
        <Tooltip title={t(translationPath + "list")}>
          <ToggleButton value="list">
            <FormatListBulletedRoundedIcon />
          </ToggleButton>
        </Tooltip>
        <Tooltip title={t(translationPath + "grid")}>
          <ToggleButton value="grid">
            <GridViewRoundedIcon />
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    </Box>
  );
});
